import { ValiError } from 'valibot';

import { API } from '@/api';
import { fetcher, HTTPError, logger } from '@/services/fetcher';

import { productsSummaryApiSchema } from '../../models';

const shipmentApi = fetcher.extend(() => ({ prefixUrl: `${API.SHIPMENT}` }));

export type GetProductSummaryRequestParams = {
  shipmentKey: number;
};

export const fetchProductsSummary = async (
  filters: GetProductSummaryRequestParams,
  { signal }: { signal?: AbortController['signal'] } = {},
) => {
  try {
    return await shipmentApi
      .get('GetShipmentProductDetailsSummary', { searchParams: filters, signal })
      .json(productsSummaryApiSchema);
  } catch (error) {
    if (error instanceof ValiError || (error instanceof Error && error.name === 'ValiError')) {
      logger.warn(
        'Validation error on GetShipmentProductDetailsSummary response',
        (error as ValiError<typeof productsSummaryApiSchema>).issues,
      );
    }
    if (error instanceof HTTPError) {
      logger.error(`Error: ${error.response.status}`);
    }
    throw error;
  }
};
